module.exports = __webpack_public_path__ + "static/media/leftArrow_header.953f6cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/leftArrow_header.png
// module id = 21
// module chunks = 0 1